import W2HelpData from './W2HelpData';
import Form1099MiscHelpData from './Form1099MiscHelpData';
import Form1099NecHelpData from './Form1099NecHelpData';

const HelpData = {
  w2: W2HelpData,
  form1099Misc: Form1099MiscHelpData,
  form1099Nec: Form1099NecHelpData,
};

export default HelpData;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpData/index.jsx